import { genericCleanedEnum } from "./genericCleanedEnum";
import { readableMaritalStatus } from "./maritalStatus";
import { readableObjective } from "./objectives";

export default {
  readableMaritalStatus,
  readableObjective,
  genericCleanedEnum
};
